







































































import Vue from 'vue'
import {
  Component, Prop, Emit, Watch,
} from 'vue-property-decorator';
import ModalWarning from '@/shared/modal/modal-warning.component.vue';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import ModalComponent from '@/shared/modal/modal.component.vue'
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import ModalOptions from '@/shared/modal/modal-options.entity';
import Contract from '@/domain/contract/entity/contract.entity';
import ContractGroupService from '@/domain/contract/service/contract-group.service';
import ContractGroupSearch from '@/domain/contract/entity/contract-group-search.entity';
import Rules from '@/shared/rules/rules';
import toDocument from '@/shared/directive/toDocument';
import validateCNPJ, { alphanumericCnpj } from '@/shared/utils/cnpj';

@Component({
  filters: {
    toDocument,
  },
  components: {
    ModalComponent,
    ModalWarning,
    VbTooltipSlot,
    LabelSlot,
  },
})
export default class ConnectContractToContractGroup extends Vue {
  @Prop({ required: true })
  show!: boolean;

  @Prop({ required: true })
  businessUnitId!: string;

  @Prop({
    required: false,
  })
  contract!: Contract;

  @Prop({
    required: true,
  })
  typeForm!: string; // create|connect

  @Prop({
    required: false,
    default: false,
  })
  noContractLink!: boolean;

  showConfirmDialog: boolean = false;

  warningMessage: string = 'O CNPJ informado já está vinculado a outro Grupo. '
    + 'Deseja utilizar o mesmo CNPJ para criar um novo Grupo de Contratos?';

  @Emit('cancel')
  cancel(): void {}

  get options(): ModalOptions {
    this.newContractGroup = this.typeForm === 'create';

    if (this.newContractGroup) {
      this.getAll();
    }

    const titleContractGroup = this.newContractGroup
      ? 'Criar Novo Grupo de Contratos'
      : 'Vincular Contrato a um Grupo de Contratos';

    return {
      title: titleContractGroup,
      titleAlign: 'center',
      showClose: false,
      showOk: true,
      labelOk: 'Salvar',
      okColor: 'bluePrimary',
      showCancel: true,
      labelCancel: 'Cancelar',
      width: 550,
      persistent: true,
    }
  }

  private searchGroups: Array<ContractGroupSearch> = [];

  private newContractGroup: boolean = false;

  private newContractGroupId: string = '';

  private newContractGroupCnpj: string = '';

  private newContractGroupName: string = '';

  private newContractGroupCustomerName: string = '';

  private valid: boolean = false;

  private rules: Rules = new Rules();

  getGroupText(item: ContractGroupSearch): string {
    if (item.cnpj.length === 14) {
      return `${toDocument(item.cnpj)} - ${item.name}`;
    }
    return `${item.cnpj} - ${item.name}`;
  }

  @Watch('show')
  getAll() {
    this.resetValidation();
    if (this.businessUnitId === undefined) {
      return;
    }

    ContractGroupService.getAll(this.businessUnitId)
      .then((response: any) => {
        this.searchGroups = response
      })
      .catch(VbSnackbarService.handleHttpError)
  }

  handleConfirm() {
    if (this.newContractGroup) {
      this.handleConfirmCreate();
    } else {
      this.handleConfirmConnect();
    }
  }

  async handleConfirmCreate() {
    if (this.newContractGroupName.toString().trim() === '') {
      VbSnackbarService.showError('Informe o Nome do Grupo de Contrato!');
      return;
    }

    const cnpj = alphanumericCnpj(this.newContractGroupCnpj);
    if (cnpj === '') {
      VbSnackbarService.showError('Informe o Número do documento do Grupo de Contrato!');
      return;
    }

    if (cnpj.length === 14 && !validateCNPJ(cnpj)) {
      VbSnackbarService.showError('Informe um CNPJ válido!');
      return;
    }

    if (await this.hasCnpjContractGroup()) {
      this.showConfirmDialog = true;
    } else {
      this.handleCreateNewContractGroup();
    }
  }

  resetValidation() {
    this.newContractGroupCnpj = '';
    this.newContractGroupName = '';
    this.newContractGroupCustomerName = '';
    this.newContractGroupId = '';
    this.showConfirmDialog = false;
  }

  confirmUseDuplicateCnpj() {
    if (!this.handleCreateNewContractGroup()) {
      VbSnackbarService.showError('Erro ao tentar criar um novo Grupo de Contrato!');
    }
  }

  async handleConfirmConnect() {
    if (!this.handleConnectContract()) {
      throw new Error('Erro ao adicionar o contrato ao Grupo de Contratos!');
    }
  }

  async hasNameContractGroup() {
    return ContractGroupService.hasNameContractGroup(
      this.businessUnitId,
      this.newContractGroupName,
      this.newContractGroupId,
    )
      .then((response: any) => {
        if (response.hasName === 1) {
          VbSnackbarService.showError('Já existe um Grupo de Contratos com o Nome informado para essa unidade de negócio!');
          return true;
        }
        return false;
      })
      .catch(VbSnackbarService.handleHttpError)
  }

  async hasCnpjContractGroup(): Promise<boolean> {
    return ContractGroupService.hasCnpjContractGroup(
      this.businessUnitId,
      alphanumericCnpj(this.newContractGroupCnpj),
    )
      .then((response: any) => response.success === false)
      .catch((error: any) => {
        VbSnackbarService.handleHttpError(error);
        return false;
      });
  }

  async handleConnectContract() {
    if (this.newContractGroupId === '') {
      VbSnackbarService.error('Selecione um Grupo de Contratos para adicionar o contrato!');
    }

    ContractGroupService.bindOrUnbindContractGroup(
      [this.contract.id],
      this.newContractGroupId,
    )
      .then((_response: any) => {
        VbSnackbarService.showSuccess('Contrato adicionado ao Grupo de Contratos com sucesso!');
        this.resetValidation();
        this.$emit('ok');
      })
      .catch(VbSnackbarService.handleHttpError)
      .finally(() => false)
  }

  async handleCreateNewContractGroup() {
    if (this.businessUnitId === undefined) {
      return;
    }

    if (!this.noContractLink && !this.contract) {
      VbSnackbarService.showError('Id do Contrato não definido!');
      return;
    }

    const contractId = this.contract ? this.contract.id : '';

    ContractGroupService.createContractGroup(
      this.businessUnitId,
      contractId,
      this.newContractGroupName,
      this.newContractGroupCustomerName,
      alphanumericCnpj(this.newContractGroupCnpj),
    )
      .then((response: any) => {
        if (response.status === 400) {
          VbSnackbarService.showError(response.messages[0]);
        }
        if (response === '' || response.status === 200) {
          VbSnackbarService.showSuccess('Grupo de Contratos criado com sucesso!');
          this.resetValidation();
          this.$emit('ok');
        }
      })
      .catch(() => VbSnackbarService.showError('Erro ao criar o Grupo de Contratos!'))
  }
}
